import React, { useState, useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { PrimaryIconButton, SecondaryIconButton } from '../../theme/index';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import { useDispatch, useSelector } from 'react-redux';
import { modalAction, modalDeleteAction } from '../../redux/reducers/Modal';
import SuccessModal from '../SuccessModal';
import DangerModal from '../DangerModal';
import { Pagination, PaginationItem, Grid } from '@mui/material';
import styled from '@mui/material/styles/styled';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { saveIdAction } from '../../redux/reducers/Delete';
import axios from 'axios';
import {collection, getDocs, addDoc, query} from 'firebase/firestore';
import db from "../../config/firebase";

const PaginationGrid = styled(Grid)(({ theme }) => `
    ul{
        justify-content: end
    }

    button:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)

const PaginationItemStyled = styled(PaginationItem)(({ theme }) => `
    svg{
        color: #000;
    }

    button:hover, svg:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)


function createData(id, documentType, documentNumber, nameLastname, email, status) {
  return { id, documentType, documentNumber, nameLastname, email, status};
}

const rows = [
  createData('1', 'passport', '000.000.000', 'Lien Rodríguez Farías', 'lienrodriguezfarias@gmail.com', true),
  createData('2', 'identification', '000.000.001', 'Yazmín Najera Briones', 'yazminnajerabriones@gmail.com', true),
  createData('3', 'passport', '000.000.002', 'Pedro Mujica', 'pedrom@gmail.com', false),

  createData('4', 'passport', '000.000.003', 'Simoneta Nieves Ibarra', 'simonetanievesibarra@hotmail.com', true),
  createData('5', 'identification', '000.000.004', 'Marilyn Bonilla Sosa', 'marilynbonillasosa@gmail.com', true),
  createData('6', 'passport', '000.000.005', 'Ulises Laureano Pina', 'uliseslaureanopina@hotmail.com', false),

  createData('7', 'passport', '000.000.006', 'Jessica Meraz Haro', 'jessicamerazharo@gustr.com', true),
  createData('8', 'identification', '000.000.007', 'Johanna Toledo Lomeli', 'johannatoledolomeli@gmail.com', true),
  createData('9', 'passport', '000.000.008', 'Pamela Espinosa Villaseñor', 'pamelaespinosavillasenor@gmail.com', false),

  createData('10', 'passport', '000.000.009', 'Lidón Chávez Valenzuela', 'lidonchavezvalenzuela@gustr.com', true),
  createData('11', 'identification', '000.000.010', 'Juan Machado', 'juanm@hotmail.com', true),
  createData('12', 'passport', '000.000.011', 'Marcel Granados Partida', 'marcelgranadospartida@hotmail.com', false),

  createData('13', 'passport', '000.000.012', 'Wilmer Patino Salcedo', 'wilmerpatinosalcedo@gmail.com', true),
  createData('14', 'identification', '000.000.013', 'Brendan Meléndez Cotto', 'brendanmelendezcotto@gmail.com', true),
  createData('15', 'passport', '000.000.014', 'Normando Armenta González', 'normandoarmentagonzalez@hotmail.com', false),
];


const Client = () => {

    const [ clients, setClients ] = useState([]);
    const [ search, setSearch ] = useState([]);
    const [ paginations, setPaginations ] = useState(0);
    const [ initResult, setInitResult ] = useState(0);
    const [ endResult, setEndResult ] = useState(10);
    const [ rows, setRows ] = useState([]);
    const searchData = useSelector( state => state.Search.data );
    const clientsData = useSelector( state => state.Create.client );
    const clientToDelete = useSelector( state => state.Delete.clientId );
    const clientStatusDelete = useSelector( state => state.Delete.status );
    const clientToEdit = useSelector( state => state.Edit.clientEdited );

    useEffect( () => {
        if (clientsData.name){
            let currentClients = [clientsData, ...clients];
            setClients(currentClients);
        }
    },[clientsData] )

    useEffect( () => {
        if(clientStatusDelete == 'SUCCESS'){
            const currentClients = clients.filter( item => item.id !== clientToDelete);
            console.log(currentClients);
            setClients(currentClients);
        }
    },[clientStatusDelete] )

    useEffect( () => {
        if(clientToEdit !== {}){
            let listEdited = clients.map( item => {
                return (item.id == clientToEdit.id) ? {...clientToEdit} : item ;
            } );

            setClients(listEdited);
        }
    },[clientToEdit] )

    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        if( page < value ){
            // aumentar
            setInitResult(initResult+10);
            setEndResult(endResult+10);
        }else{
            // disminuir
            setInitResult(initResult-10);
            setEndResult(endResult-10);
        }
        setPage(value);
    };

    useEffect( () => {
        
        const petition = async () => {
            const q = query(collection(db, "client"));
            const querySnapshot = await getDocs(q);
            let clientArray = [];
            querySnapshot.forEach((doc) => {
                clientArray.push({id: doc.id, ...doc.data()});
            });
            addData(clientArray);
        }

        const addData = data => {
            setClients(data.reverse());
        }

        petition();
        
    },[] );

    useEffect( () => {
        const textToSearch = searchData.toLowerCase();
        const mappingArray = rows.filter( (item, index) => {
            return ( index >= initResult && index < endResult ) ? item : null;
        } );

        if(searchData !== ''){
            const filteredElements = clients.filter( (item, index) => item.name.toLowerCase().includes(textToSearch) || 
                                                  item.lastname.toLowerCase().includes(textToSearch) ||
                                                  item.documentNumber.includes(textToSearch) ||
                                                  item.email.toLowerCase().includes(textToSearch) );
            setSearch(filteredElements);
        }else{
            // const filteredElements = mappingArray.filter( (item, index) => item.name.toLowerCase().includes(textToSearch) || 
            //                                       item.lastname.includes(textToSearch) ||
            //                                       item.documentNumber.includes(textToSearch) ||
            //                                       item.email.toLowerCase().includes(textToSearch) );
            // setClients(filteredElements);
        }

        setPaginations(Math.ceil(rows.length/10))
    },[searchData, initResult, endResult] );

    const dispatch = useDispatch();
    const [ showModal, setShowModal ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [ modalForm, setModalForm ] = useState('');
    const [ deleteModal, setDeleteModal ] = useState('');
    const [ clientData, setClientData ] = useState('');
    const modalStatus = useSelector( state => state.Modal.modalState );
    const deleteModalStatus = useSelector( state => state.Modal.deleteModalState );

    useEffect( () => {
        setShowModal(modalStatus);
        if (!modalStatus) setModalForm('')
    }, [modalStatus] );
    
    useEffect( () => {
        setShowDeleteModal(deleteModalStatus);
      }, [deleteModalStatus] );

    const editClient = (data) => {
        setModalForm('editClient');
        setClientData(data);
        setDeleteModal('');
        dispatch(modalAction());
        //setModalForm('editClient');
    }

    const deleteClient = (id) => {
        setModalForm('');
        dispatch(modalDeleteAction());
        setDeleteModal('client');
        dispatch(saveIdAction(id));
    }

    const getDocumentName = doc => {
        if(doc == "passport") return 'Pasaporte';
        if(doc == "v") return 'V';
        if(doc == "E") return 'E';
    }

  return (
    <>
        {
            (showModal && modalForm !== '' ) &&
            <SuccessModal view={modalForm} client={clientData} />
        }
        {
            (showDeleteModal && deleteModal !== '' ) &&
            <DangerModal view={deleteModal} />
        }
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Tipo documento</TableCell>
                    <TableCell>Nº documento</TableCell>
                    <TableCell>Nombre y apellido</TableCell>
                    <TableCell>E-mail</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="center">Acciones</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                { (searchData !== '') && search.map((row, index) => (
                    <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    {
                        (!row.id) ?
                        <TableCell component="th" scope="row">
                                <FiberNewIcon sx={{ color: '#FF6961' }} />
                        </TableCell>
                        :
                        <TableCell component="th" scope="row">{row.id.substring(0, 5)}</TableCell>
                    }
                    <TableCell>{ getDocumentName(row.documentType) }</TableCell>
                    <TableCell>{row.documentNumber}</TableCell>
                    <TableCell>{row.name} {row.lastname}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{
                        (row.status === "true") ? 'Activado' : 'Desactivado'
                    }</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{
                        <>
                            <PrimaryIconButton aria-label="delete" sx={{ mx: '.4rem' }} onClick={ () => editClient(row) }>
                                <EditIcon />
                            </PrimaryIconButton>
                            <SecondaryIconButton aria-label="delete" onClick={ () => deleteClient(row.id) }>
                                <DeleteIcon />
                            </SecondaryIconButton>
                        </>
                    }</TableCell>
                    </TableRow>
                ))}



                { (searchData == '') && clients.map((row, index) => (
                    <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    {
                        (!row.id) ?
                        <TableCell component="th" scope="row">
                                <FiberNewIcon sx={{ color: '#FF6961' }} />
                        </TableCell>
                        :
                        <TableCell component="th" scope="row">{row.id.substring(0, 5)}</TableCell>
                    }
                    <TableCell>{ getDocumentName(row.documentType) }</TableCell>
                    <TableCell>{row.documentNumber}</TableCell>
                    <TableCell>{row.name} {row.lastname}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{
                        (row.status === "true") ? 'Activado' : 'Desactivado'
                    }</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{
                        <>
                            <PrimaryIconButton aria-label="delete" sx={{ mx: '.4rem' }} onClick={ () => editClient(row) }>
                                <EditIcon />
                            </PrimaryIconButton>
                            <SecondaryIconButton aria-label="delete" onClick={ () => deleteClient(row.id) }>
                                <DeleteIcon />
                            </SecondaryIconButton>
                        </>
                    }</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>

        <Grid container sx={{ justifyContent: 'end', textAlign: 'end', mt: 2 }}>
            <PaginationGrid item xs={12}>
                <Pagination
                    count={paginations}
                    onChange={handleChange}
                    renderItem={(item) => (
                        <PaginationItemStyled
                        components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                        />
                    )}
                />
            </PaginationGrid>
        </Grid>
    </>
  )
}

export default Client